/**
 * Small HTML helpers used by API schemas to normalise WP responses.
 *
 * The WP REST API hands back `title.rendered` etc. as HTML — even for
 * plain text fields. Legacy versions showed entities like `&amp;`
 * verbatim in titles; we decode them once at the schema boundary so
 * the rest of the app never deals with HTML in domain models.
 */

/**
 * Decode HTML entities in a string. Uses a temporary DOM node, which
 * is safe (no script execution) because we only ever read `.value`.
 *
 * Works in both jsdom (tests) and the browser. Falls back to the raw
 * string in SSR-ish environments without DOM.
 */
export function decodeHtmlEntities(s: string): string {
  if (typeof document === 'undefined') return s
  const el = document.createElement('textarea')
  el.innerHTML = s
  return el.value
}

/** Strip HTML tags. Naïve — fine for plain WP excerpts, not for safe HTML rendering. */
export function stripTags(html: string): string {
  return html.replace(/<[^>]*>/g, '')
}

/** Common combination — decode entities and drop tags. */
export function htmlToPlain(html: string): string {
  return decodeHtmlEntities(stripTags(html)).trim()
}
